import { render, staticRenderFns } from "./BorcSenetleri.vue?vue&type=template&id=84fa8c48&scoped=true"
import script from "./BorcSenetleri.vue?vue&type=script&lang=js"
export * from "./BorcSenetleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fa8c48",
  null
  
)

export default component.exports